<template>
    <div class="w-full">
        <div class="twitter-timeline"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TwitterFeed',

  mounted () {
    this.load()
  },

  watch: {
    system () {
      this.load()
    }
  },

  methods: {
    load () {
      window.twttr.widgets.createTimeline(
        {
          sourceType: 'profile',
          screenName: this.system.twitter
        },
        this.$el.querySelector('.twitter-timeline')
      )
    }
  },

  computed: {
    ...mapState([ 'system' ])
  }
}
</script>
